<template>
  <div>
    <v-dialog
        v-model="dialog"
        max-width="600"
        height="auto"
    >
      <v-card>
        <v-toolbar
            color="primary"
            class="text-white"
        >انتخاب دسته بندی
        </v-toolbar>
        <v-card-text>
          <render-category></render-category>
        </v-card-text>
        <div class="col-md-10 mx-auto">
          <v-btn
              block
              @click="setParentId"
              color="primary"
              outlined
              large
          >ثبت دسته بندی
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-text-field
        :label="parentName"
        v-model="category"
        outlined
        clearable
        clear-icon="mdi-close-circle-outline"
        required
        @click="dialog=true"
        dense
        prepend-inner-icon="fa fa-pencil-alt"
        class="mt-1"
    ></v-text-field>
  </div>
</template>

<script>
import { Bus} from "../../../main";
import renderCategory from "./renderCategory"

export default {
  name: "adminCategory",
  components: {renderCategory},
  props: {
    parentName: {
      default: 'آیدی والد'
    },

  },
  data() {
    return {
      parent_id: null,
      category: '',
      dialog: false,
      categories: []
    }
  },
  created() {
    this.getCategory();
  },
  methods: {
    getCategory() {
      this.$api.get('/admin/category').then((response) => {
        this.categories = response.data.data;
      })
    },
    setParentId() {
      this.category = this.categories.find((x) => x.id === this.parent_id).title;
      this.dialog = false;
    }
  },
  watch: {
    parent_id: {
      handler: function (value) {
        Bus.$emit('getCategory', value);
      },
      deep: true
    },
    categories() {
      if (typeof this.parent_id === "string") {
        this.category = this.parent_id;
        this.parent_id = this.categories.find((x) => x.title === this.parent_id).id
      }
    },
    category: {
      handler(value) {
        Bus.$emit('categoryName', value);
      },
      deep: true
    }
  },
  mounted() {
    Bus.$on('getCategoryId', value => {
      this.parent_id = value
    })
  }
}
</script>

<style scoped>

</style>